import React from 'react';

/** Skeleton row for list views; six are rendered by default. */
export function LoadingSkeleton({ rows = 6 }: { rows?: number }): React.JSX.Element {
  return (
    <div aria-busy="true" aria-live="polite" data-testid="loading-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          style={{
            height: '2.5rem',
            background: 'var(--bg-secondary)',
            borderRadius: '0.25rem',
            margin: '0.25rem 0',
            opacity: 0.6,
          }}
        />
      ))}
    </div>
  );
}

interface ErrorStateProps {
  error: Error;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps): React.JSX.Element {
  return (
    <div
      role="alert"
      style={{
        padding: '1rem',
        border: '1px solid var(--severity-critical-border, #dc2626)',
        background: 'var(--severity-critical-bg, #fef2f2)',
        color: 'var(--severity-critical-text, #991b1b)',
        borderRadius: '0.375rem',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>
        Something went wrong loading this data.
      </div>
      <details>
        <summary>Technical details</summary>
        <pre style={{ marginTop: '0.5rem', fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>
          {error.message}
        </pre>
      </details>
      {onRetry && (
        <button
          className="btn btn-secondary"
          style={{ marginTop: '0.5rem' }}
          onClick={onRetry}
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ message }: { message: string }): React.JSX.Element {
  return (
    <div
      style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'var(--text-secondary)',
      }}
    >
      {message}
    </div>
  );
}
